import { render, staticRenderFns } from "./DashboardLayout.vue?vue&type=template&id=489054ab&scoped=true&"
import script from "./DashboardLayout.vue?vue&type=script&lang=js&"
export * from "./DashboardLayout.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLayout.vue?vue&type=style&index=0&id=489054ab&prod&lang=css&"
import style1 from "./DashboardLayout.vue?vue&type=style&index=1&id=489054ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489054ab",
  null
  
)

export default component.exports